import { render } from "./FeatureFlagAuditLog.vue?vue&type=template&id=11be47a2&scoped=true"
import script from "./FeatureFlagAuditLog.vue?vue&type=script&lang=js"
export * from "./FeatureFlagAuditLog.vue?vue&type=script&lang=js"

import "./FeatureFlagAuditLog.vue?vue&type=style&index=0&id=11be47a2&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11be47a2"]])

export default __exports__